import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import MDButton from 'components/MDButton';

function ProductionName({ id, formattedValue }) {
    return (
        <MDButton
            variant="text"
            color="info"
            component={Link}
            to={`../productions/${id}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {formattedValue}
        </MDButton>
    );
}

export default memo(ProductionName);
